__turbopack_context__.v({
  "avatar": "VgdIbG_avatar",
  "avatarImage": "VgdIbG_avatarImage",
  "chevron": "VgdIbG_chevron",
  "content": "VgdIbG_content",
  "icon": "VgdIbG_icon",
  "label": "VgdIbG_label",
  "name": "VgdIbG_name",
  "trigger": "VgdIbG_trigger",
});
